export const BrlCurrencyFormatter = (
  value: string | number | null | undefined
): string => {
  const parsedValue = typeof value === "string" ? parseFloat(value) : value;
  if (typeof parsedValue === "number" && parsedValue === 0) {
    return "R$ 0,00";
  }

  return parsedValue && !isNaN(parsedValue)
    ? new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    }).format(parsedValue)
    : "Valor não disponível";
};

